// extracted by mini-css-extract-plugin
module.exports = {"container":"ow0gTlK7tbPxl0gPWcthU"};